import { sectionTemplateInitialStatus as initialStatus } from './sectionTemplateInitialStatus';
import { sectionTemplateInitialValues as initialValues } from './sectionTemplateInitialValues';

export default { initialStatus, initialValues };
